import { CircularProgress, Box, Modal, Button, Typography } from "@mui/material";
import React from "react";
import { ArchiveApplicationModalController, ArchiveApplicationModalControllerDelegate } from "./controller";

interface State {
  isLoading: boolean;
}

interface Props {
  applicationId: number;
  delegate: ArchiveApplicationModalDelegate;
}

const boxStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: 600,
  width: "70%",
  bgcolor: 'background.paper',
  border: '2px solid red',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

export interface ArchiveApplicationModalDelegate {
  shouldCloseModal: () => void;
  applicationShouldLogout: () => void;
  genericError: () => void;
  didArchiveApplication: () => void;
}

class ArchiveApplicationModal extends React.Component<Props, State> implements ArchiveApplicationModalControllerDelegate {

  controller: ArchiveApplicationModalController

  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false
    }
    this.controller = new ArchiveApplicationModalController(this);
  }

  // delegate
  didArchiveApplication(){
    this.props.delegate.didArchiveApplication();
  }

  genericError() {
    this.props.delegate.genericError();
  };

  applicationShouldLogout() {
    this.props.delegate.applicationShouldLogout();
  };

  // internals
  didClickDelete() {
    this.setState({isLoading: true});
    const token = localStorage.getItem("AccessToken")!;
    this.controller.archiveApplication(token, this.props.applicationId)
  }

  didClickClose() {
    this.props.delegate.shouldCloseModal();
  }

  renderLoading() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <CircularProgress />
      </Box>
    );
  }

  renderForm() {
    return (
      <Box
        alignItems="center"
        display="flex"
        flexDirection="column"
        marginTop={2}
      >
        <Typography mb={2} variant="h3" color="red">
          Confirmar Arquivamento
        </Typography>
        <Typography variant="body1">
          Tem certeza que deseja arquivar esta aplicação?
        </Typography>
        <Typography variant="body1">
          Você apenas poderá restaurá-la entrando em contato com a administração
        </Typography>
        <Box m={2} display="flex" flexDirection="row" gap={1}>
          <Button
            variant="contained"
            color="error"
            onClick={() => this.didClickDelete()}
          >
            Arquivar Aplicação
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => this.didClickClose()}
          >
            Cancelar
          </Button>
        </Box>
      </Box>
    );
  }

  // Internals
  render() {
    return (
      <Modal
        open
        onClose={() => this.didClickClose()}
      >
        <Box
          sx={boxStyle}
        >
          {this.state.isLoading ? this.renderLoading() : this.renderForm()}
        </Box>
      </Modal>
    );
  }
}

export default ArchiveApplicationModal;
